import { removeHTML } from "./joditEditor";
import { templateTags } from "../constants";

const getTemplateTagLabels = (): Record<string, string> => {
  const labels: Record<string, string> = {};
  
  Object.values(templateTags).forEach((category) => {
    Object.entries(category).forEach(([key, label]) => {
      labels[key] = label;
    });
  });
  
  return labels;
};

export const replaceTemplateTagsForPreview = (
  content: string,
  showRawTags: boolean = false,
  preserveHtml: boolean = false
): string => {
  if (!content) return "";
  
  const tagPattern = /<span class="joditTag">\s*(@[\w.]+)\s*<\/span>/gi;
  let processedContent = content;
  
  if (showRawTags) {
    processedContent = processedContent.replace(tagPattern, (match, tag) => {
      return tag.trim();
    });
  } else {
    const tagLabels = getTemplateTagLabels();
    
    processedContent = processedContent.replace(tagPattern, (match, tag) => {
      const trimmedTag = tag.trim();
      return tagLabels[trimmedTag] || trimmedTag;
    });
    
    Object.entries(tagLabels).forEach(([tag, label]) => {
      const regex = new RegExp(tag.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "gi");
      processedContent = processedContent.replace(regex, label);
    });
  }

  if (preserveHtml) {
    return processedContent;
  }
  
  processedContent = processedContent.replace(/<br\s*\/?>/gi, "\n");
  processedContent = processedContent.replace(/<\/p>/gi, "\n");
  processedContent = processedContent.replace(/<p[^>]*>/gi, "");
  processedContent = removeHTML(processedContent);
  
  processedContent = processedContent
    .replace(/\n\s*\n\s*\n/g, "\n\n")
    .replace(/[ \t]+/g, " ")
    .trim();
  
  return processedContent;
};

export const convertHtmlToPlainText = (htmlContent: string): string => {
  if (!htmlContent) return "";
  
  let plainText = htmlContent;
  
  plainText = plainText.replace(/<br\s*\/?>/gi, "\n");
  plainText = plainText.replace(/<\/p>/gi, "\n");
  plainText = plainText.replace(/<p[^>]*>/gi, "");
  
  plainText = removeHTML(plainText);
  
  plainText = plainText
    .replace(/\n\s*\n\s*\n/g, "\n\n")
    .replace(/[ \t]+/g, " ")
    .trim();
  
  return plainText;
};
